import Setting from ".";
const SettingsRoutes = {
  routes: [
    {
      path: "/settings",
      component: Setting,
      exact: true,
    },
  ],
};
export default SettingsRoutes;
